const { getCookie } = require('./cookies')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @returns {boolean}
 */
function readOnly () {
  return getCookie('access_scope') === 'read_only'
}

module.exports = { readOnly }
